import ContainerCelulaPg from './components/Container';
import { Outlet } from 'react-router-dom';

export default function Celula() {

  return (
      <>
        <ContainerCelulaPg/>
        <Outlet/>
      </>
  )
}
